"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Separator2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _Heading = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Heading"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _LoggedPanelLinks2 = _interopRequireDefault(require("./LoggedPanelLinks"));
var _ProfileImage2 = _interopRequireDefault(require("../../components/ProfileImage"));
var _useGetUser = _interopRequireDefault(require("../../components/useGetUser"));
var _jsxRuntime = require("react/jsx-runtime");
var _ProfileImage, _LoggedPanelLinks, _Separator;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LoggedPanelTop = () => {
  var _user$displayName, _user$email;
  const user = (0, _useGetUser.default)();
  const name = (_user$displayName = user === null || user === void 0 ? void 0 : user.displayName) !== null && _user$displayName !== void 0 ? _user$displayName : "";
  const email = (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : "";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      direction: "row",
      children: [_ProfileImage || (_ProfileImage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage2.default, {
        imgSize: "large"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spacing: "XXSmall",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading.default, {
          as: "h2",
          type: "title2",
          spaceAfter: "none",
          children: name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          children: email
        })]
      })]
    }), _LoggedPanelLinks || (_LoggedPanelLinks = /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoggedPanelLinks2.default, {})), _Separator || (_Separator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator2.default, {}))]
  });
};
var _default = LoggedPanelTop;
exports.default = _default;